import { IRpcService } from '../RpcService';
import { IRuncodeService, RuncodeResponse } from './runcodeServiceTypes';

export class RuncodeService implements IRuncodeService {
	constructor(private readonly rpc: IRpcService) {}

	public async executeCode(
		code: string,
		target: 'client' | 'server',
	): Promise<RuncodeResponse> {
		if (target === 'client') {
			const response = await this.rpc.invokeClient<{
				result?: unknown;
				error?: string;
			}>('dev:executeScript', code);

			return this.formatResponse(response ?? null);
		}

		const response = await this.rpc.invokeServer<{
			result?: unknown;
			error?: string;
		}>('dev:executeScript', {
			script: code,
		});

		return this.formatResponse(response ?? null);
	}

	public async exitMenu(): Promise<void> {
		await this.rpc.invokeClient('runcode:exitMenu');
	}

	private formatResponse(
		response: { result?: unknown; error?: string } | null,
	): RuncodeResponse {
		if (!response) {
			return { result: undefined, error: null };
		}

		if (response.error) {
			return { result: undefined, error: response.error };
		}

		const formattedResult =
			typeof response.result === 'string'
				? response.result
				: response.result !== undefined
				? JSON.stringify(response.result, null, 2)
				: 'undefined';

		return { result: formattedResult, error: null };
	}
}
